import { buildNavigationUrl } from "../../../util/buildNavigationUrl";
const buildConsignmentNavigationTargetUrl = ({
  activeSubPage = "form",
  listContext = {},
  recordId,
  status = "all",
} = {}) => {
  const query = new URLSearchParams(listContext.locationSearch || "");
  if (status === "all") query.delete("status");
  else if (status) query.set("status", status);
  return buildNavigationUrl(`/consignment/${recordId}/${activeSubPage}`, query);
};

export { buildConsignmentNavigationTargetUrl };
